import { TableColumnType } from "antd";

import { RightAlignedCell } from "../MidstreamNavigatorTable.styles";
import type { WellDownstreamData } from "../types";

// Column definitions for Well mode (Downstream Report)
export function getWellColumns(): TableColumnType<WellDownstreamData>[] {
  return [
    {
      title: "UWID",
      dataIndex: "wellId",
      key: "wellId",
      width: 120
    },
    {
      title: "Destination Facility",
      dataIndex: "destinationFacility",
      key: "destinationFacility",
      width: 130
    },
    {
      title: "Facility Operator",
      dataIndex: "facilityOperator",
      key: "facilityOperator",
      width: 130
    },
    {
      title: "Contribution % (Current Month)",
      dataIndex: "fraction",
      key: "fraction",
      width: 145,
      render: (value: number) => (
        // Format as percentage with 1 decimal place
        <RightAlignedCell>
          {value !== null && value !== undefined ? (value * 100).toFixed(1) : ""}
        </RightAlignedCell>
      )
    },
    {
      title: "Depth",
      dataIndex: "depth",
      key: "depth",
      width: 70,
      render: (value: number) => (
        <RightAlignedCell>
          {value !== null && value !== undefined ? value : ""}
        </RightAlignedCell>
      )
    }
  ];
}
